import { render } from "./MobilePlanetsTable.vue?vue&type=template&id=43f52e57&scoped=true"
import script from "./MobilePlanetsTable.vue?vue&type=script&lang=js"
export * from "./MobilePlanetsTable.vue?vue&type=script&lang=js"

import "./MobilePlanetsTable.vue?vue&type=style&index=0&id=43f52e57&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2623155984/src/jamakkol-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43f52e57"]])

export default __exports__